import { NaniumObject, Type } from "nanium/objects";
import { Facility } from "./facility.entity";
import { FacilityGetRequest } from "../services/facility/get.contract";

export class News extends NaniumObject<News> {
  static strictDefault: boolean = true;

  @Type(String) id?: string;
  @Type(String) headline?: string;
  @Type(String) content?: string;

  @Type(String) titleImage?: string;
  @Type(String) titleVideo?: string;

  @Type(String) authorId?: string;
  @Type(Date) dateCreated?: Date;
  @Type(Date) datePublished?: Date;

  // deprecated, use datePublished instead
  @Type(Boolean) published?: boolean;

  @Type(String) owningFacility?: string;
  @Type(Facility) owningFacilityObj?: Facility;
  // Admin-only fallback: free-text facility name used when no registered
  // facility is linked (owningFacility empty). Mutually exclusive with owningFacility.
  @Type(String) owningFacilityName?: string;

  @Type(Number) viewsLast14Days?: number;
  @Type(Number) viewsPrevious14Days?: number;
  @Type(Number) viewsLast365Days?: number;

  async loadOwningFacility() {
    if (this.owningFacility) {
      this.owningFacilityObj = await new FacilityGetRequest({id: this.owningFacility}).execute();
    }
  }
}
